import * as React from 'react';
import {
    IGroupedComboBoxItemEventsInternal,
    IItemCommands,
    TouchEventCallbackInternal,
} from './GroupedComboBoxDropDown.types.internal';
import { IGroupedComboBoxItem } from '../GroupedComboBox/GroupedComboBox.types.shared';
import {
    IGroupedComboBoxDropDownIconResources,
    GroupedComboBoxOnRenderTooltip,
    IRenderFunction,
    GroupedComboBoxOnRenderMenuProps,
    GroupedComboBoxTooltipFunction,
} from './GroupedComboBoxDropDown.types.shared';

export type GroupedComboBoxContext = IGroupedComboBoxItemEventsInternal & {
    submenuMaxWidth?: number;
    submenuMaxHeight?: number;
    onSubmenuOpen?: (
        item: IGroupedComboBoxItem,
        menuCommands: IItemCommands,
        parentGroupKey?: string
    ) => void;
    onSubmenuClose?: () => void;
    iconResources?: IGroupedComboBoxDropDownIconResources;
    onRenderTooltip?: GroupedComboBoxOnRenderTooltip;
    onRenderMenu?: IRenderFunction<GroupedComboBoxOnRenderMenuProps>;
    onTouchStart?: TouchEventCallbackInternal;
    getItemTooltip?: GroupedComboBoxTooltipFunction;
};

export const DropDownContext = React.createContext<GroupedComboBoxContext>({});
